<template>
  <div class="drugInfo">
    <el-form :inline="true" :model="searchForm" class="demo-form-inline" label-width="80px">
      <el-form-item label="名称" label-width="40px">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.name" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="编码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.code" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="拼音码">
        <el-input style="width: 140px" @input="search" clearable v-model="searchForm.pinyin" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="药厂">
        <DicInput @fieldId="fieldId($event,'drugFactoryId')"  :initName="searchForm.drugFactoryId" :dicType="2"></DicInput>
      </el-form-item>
      <el-form-item label="药品类型">
        <DicInput @fieldId="fieldId($event,'drugType')" :initName="searchForm.drugType"  :dicType="3"></DicInput>
      </el-form-item>
    </el-form>
    <div style="margin-bottom: 20px">
      <el-button type="primary" @click="search">查询<i class="el-icon-search el-icon--right"></i></el-button>
      <el-button type="info" @click="clear">重置<i class="el-icon-refresh-right el-icon--right"></i></el-button>
      <el-button type="warning" @click="addItem">新增<i class="el-icon-plus el-icon--right"></i></el-button>
    </div>
    <div style="border: 1px solid #c9cdd6">
      <el-table
          :header-cell-style="{background:'#F5F5F5'}"
          :data="tableData"
          max-height="600"
          style="width: 100%"
      >
        <el-table-column
            prop="name"
            label="名称">
        </el-table-column>
        <el-table-column
            prop="code"
            label="编号">
        </el-table-column>
        <el-table-column
            prop="factoryCode"
            label="厂家编码"
            align="center">
        </el-table-column>
        <el-table-column
            prop="factoryName"
            label="厂家名称"
            align="center">
        </el-table-column>
        <el-table-column
            prop="pinYinCode"
            label="药品拼音码"
            align="center">
        </el-table-column>
        <el-table-column
            prop="drugTypeName"
            label="药品分类名称"
            align="center">
        </el-table-column>
        <el-table-column
            prop="density"
            label="药品密度"
            align="center">
        </el-table-column>
        <el-table-column
            prop="equivalentRatio"
            label="当量比"
            align="center">
        </el-table-column>
        <el-table-column
            prop="maximumDosing"
            label="最大用药量"
            align="center">
        </el-table-column>
        <el-table-column
            prop="warning"
            label="用药警告"
            align="center">
        </el-table-column>
        <el-table-column
            prop="functions"
            label="功效"
            align="center">
        </el-table-column>
        <el-table-column
            prop="note"
            label="备注"
            align="center">
        </el-table-column>
        <el-table-column
            prop="address"
            fixed="right"
            width="150"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editorClick(scope.row)">编辑</el-button>
            <!--            <el-button type="text" size="medium" @click="deleteClick(scope.row.id)">删除</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px">
      <Pagination :total='total' :currentPage='currPage' :pageSize='pageSize' @handleSizeChange='handleSizeChange'
                  @handleCurrentChange='handleCurrentChange'></Pagination>
    </div>
    <el-dialog
        :title="modelTitle"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="30%">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
        <el-form-item label="名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="编号" prop="code">
          <el-input v-model="ruleForm.code" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.note" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="厂家名称" required>
          <DicInput style="width: 100%" :initName="ruleForm.factoryId"  :defaultName="ruleForm.factoryName" @fieldId="ruleFormFieldId($event,'factoryId')" :dicType="2"></DicInput>
        </el-form-item>
        <el-form-item label="药品分类名称" required>
          <DicInput style="width: 100%" :initName="ruleForm.drugTypeId" :defaultName="ruleForm.drugTypeName"  @fieldId="ruleFormFieldId($event,'drugTypeId')" :dicType="3"></DicInput>
        </el-form-item>
        <el-form-item label="药品拼音码" required>
         <el-input v-model="ruleForm.pinYinCode" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="药品密度" prop="density">
          <el-input v-model="ruleForm.density" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="当量比" prop="equivalentRatio">
          <el-input v-model="ruleForm.equivalentRatio" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="最大用药量" prop="maximumDosing">
          <el-input v-model="ruleForm.maximumDosing" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="用药警告">
          <el-input v-model="ruleForm.warning" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="功效">
          <el-input v-model="ruleForm.functions" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import DicInput from "@/components/DicInput";
export default {
  name: "drugInfo",
  data() {
    return {
      tableData: [],
      searchForm: {
        drugFactoryId: '',
        drugType: '',
      },
      modelTitle: '新增设备',
      dialogVisible: false,
      ruleForm: {
        code:'',
        name:'',
        density:'',
        equivalentRatio:'',
        maximumDosing:'',
        factoryId:null,
        drugTypeId:null,
      },
      rules: {
        name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        code: [
          {required: true, message: '请输入编码', trigger: 'blur'},
        ],
        density: [
          {required: true, message: '请输入药品密度', trigger: 'blur'},
          { pattern: /^(?:[1-9]\d*|0)?(?:\.\d+)?$/, message: '只支持正浮点数字' },
          { max: 10, message: '长度支持6个字符', trigger: 'blur' }
        ],
        equivalentRatio: [
          {required: true, message: '请输入当量比', trigger: 'blur'},
          { pattern: /^(?:[1-9]\d*|0)?(?:\.\d+)?$/, message: '只支持正浮点数字' },
          { max: 10, message: '长度支持6个字符', trigger: 'blur' }
        ],
        maximumDosing: [
          {required: true, message: '请输入最大用药量', trigger: 'blur'},
          { pattern: /^(?:[1-9]\d*|0)?(?:\.\d+)?$/, message: '只支持正浮点数字' },
          { max: 10, message: '长度支持6个字符', trigger: 'blur' }
        ],
      },
      areaId: '',
      total: 0, //总条数
      currPage: 1,//当前页码
      pageSize: 10, //每页条数
    }
  },
  components: {
    //someComponent
    Pagination,
    DicInput
  },
  methods: {
    //搜索
    search() {
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    clear() {
      this.searchForm = {
        operatorId: '',
        pharmacyId: '',
        drugFactoryId:'',
        drugType:'',
        code: '',
      }
      this.currPage = 1 //当前页码
      this.pageSize = 10 //每页条数
      this.init()
    },
    fieldId(item,name){ // 字典
      if(item.id){
        this.searchForm[name]=item.id
      }else {
        this.searchForm[name]=''
      }
    },
    ruleFormFieldId(item,name){ // 字典
      if(item.id){
        if(name==='factoryId'){
          this.ruleForm.factoryName=item.name
          this.ruleForm.factoryCode=item.code
          this.ruleForm.factoryId=item.id
        }else {
          this.ruleForm.drugTypeName=item.name
          this.ruleForm.drugTypeId=item.id
        }
      }else {
        this.ruleForm[name]=''
      }
    },
    addItem() {
      this.modelTitle = '新增药品信息'
      this.ruleForm = {
        code:'',
        name:'',
        density:'',
        equivalentRatio:'',
        maximumDosing:'',
        factoryId:null,
        drugTypeId:null,
      }
      this.dialogVisible =true
    },
    editorClick(row) {
      this.modelTitle = '编辑药品信息'
      this.areaId = row.id
      this.ruleForm = {
        ...row,
        density:String(row.density),
        equivalentRatio:String(row.equivalentRatio),
        maximumDosing:String(row.maximumDosing),
      }
      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(!this.ruleForm.factoryId){
            this.$message.error('系统无法查询到该厂家');
            return
          }
          if(!this.ruleForm.drugTypeId){
            this.$message.error('系统无法查询到该药品分类');
            return
          }
          let data = {
            ...this.ruleForm,
          }
          if (this.modelTitle === '编辑药品信息') {
            this.axios
                .put("api/DrugInfo?id=" + this.areaId, data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          } else {
            this.axios
                 .post("api/DrugInfo", data).then((res) => {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.$refs[formName].resetFields();
              this.dialogVisible = false
              this.init()
            })
          }
        } else {
          return false;
        }
      });
    },
    // deleteClick(id) {
    //   let data = {
    //     id: id
    //   }
    //   this.axios
    //        .delete("api/ServiceManage", {params: data}).then((res) => {
    //     this.$message({
    //       message: '操作成功',
    //       type: 'success'
    //     });
    //   }).finally(error => {
    //     this.init()
    //   })
    // },
    // ----------分页控制-------------
    handleSizeChange(val) {
      this.pageSize = val
      this.init()
    },
    handleCurrentChange(val) {
      this.currPage = val
      this.init()
    },
    // list
    init() {
      let data = {
        ...this.searchForm,
        page: this.currPage,
        pageSize: this.pageSize,
      }
      this.axios
          .get("api/DrugInfo", {params: data})
          .then((res) => {
            this.tableData = res.list
            // this.tableData.forEach(item => {
            //   switch (item.systemServiceType) {
            //     case 0:
            //       item.systemServiceTypeName = '数据库服务器'
            //       break;
            //     case 1:
            //       item.systemServiceTypeName = 'Api服务器'
            //       break;
            //     case 2:
            //       item.systemServiceTypeName = '采集服务器'
            //       break;
            //     case 3:
            //       item.systemServiceTypeName = '数据缓存服务器'
            //       break;
            //   }
            // })
            this.total = res.count
          })
    }
  },
  mounted() {
    //
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.drugInfo {

}
</style>